import React, { useContext, useEffect, useState } from "react";
import { Button, Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import TableToolbar from "../../../../components/Table/TableToolbar";
import SingleSelect from "../../../../components/SelectField/SingleSelect";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ThemeTable from "../../../../components/Table/ThemeTable";
import { getIssuesByDate } from "../../../../services/apiservices/issues";
import dayjs from "dayjs";
import { getClientsList } from "../../../../services/apiservices/client";
import { FormatedDates } from "../../../../services/helpers";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EmailRoundedIcon from "@material-ui/icons/EmailRounded";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../Report.module.scss";
import { useMediaQuery } from "@mui/material";
import { downloadExcel, downloadPDF } from "../../DownloadReportUtils";
import * as Excel from "exceljs";
import { getAllEmployee } from "../../../../services/apiservices/employee";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import { getSettings } from "../../../../services/apiservices/settings";

const IssuesReports = () => {
  const csvHeaders = [
    "Client Name",
    "Date",
    "Issue Number",
    "Created By",
    "Last Response",
    "Status",
    "Priority",
  ];

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState("All");
  const [clientName, setClientName] = useState("All");
  const [clientNameList, setClientNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const [settingsData, setSettingsData] = useState();
  const [clientsList, setClientList] = useState([]);
  const [allUsers, setAllUsers] = useState();
  const [statusList, setStatusList] = useState([
    { label: "All", value: "All" },
  ]);
  const [clientsListMaster, setClientsListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const localClientID = localStorage.getItem("clientId");
  const localCompanyId = localStorage.getItem("companyId");
  const { setReportData } = auth || {};
  const companyId =
    auth?.userProfile?.role === "Client"
      ? localCompanyId
        ? localCompanyId
        : auth?.userProfile?.companyId
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;
  const navigate = useNavigate();

  const getColumns = () => {
    const columns = [
      {
        id: "clientName",
        numeric: false,
        disablePadding: false,
        label: "Client Name",
        isSortable: false,
      },
      {
        id: "date",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
      },
      {
        id: "issueNumber",
        numeric: false,
        disablePadding: false,
        label: "Issue Number",
        isSortable: false,
      },
      {
        id: "createdBy",
        numeric: false,
        disablePadding: false,
        label: "Created By",
        isSortable: false,
      },
      {
        id: "lastRes",
        numeric: false,
        disablePadding: false,
        label: "Last Response",
        isSortable: false,
      },
      {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
        isSortable: false,
      },
      {
        id: "priority",
        numeric: false,
        disablePadding: false,
        label: "Priority",
        isSortable: false,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
    ];
    return columns;
  };

  const handleclientNameChange = (e) => {
    const str = e.target.value;
    setClientName(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.client.id === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const handelStatusChange = (e) => {
    const str = e.target.value;
    setStatus(str);

    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster.filter((itme) => {
          let returnFlg = true;
          if (clientName !== "All" && returnFlg) {
            returnFlg = itme?.client.id === clientName;
          }
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.status === str;
          }
          return returnFlg;
        })
      );
    }
  };

  useEffect(() => {
    if (!companyId) return;

    const fetchAllData = async () => {
      try {
        const [settingsRes, employeesRes] = await Promise.all([
          new Promise((resolve) =>
            getSettings("client_settings", companyId, (res) => resolve(res?.data || []))
          ),
          new Promise((resolve) =>
            getAllEmployee((res) => resolve(res?.data || []))
          ),
        ]);

        const filteredSettings = settingsRes?.filter(
          (item) => !item.deleted
        );
        setSettingsData(filteredSettings);

        const filteredEmployees = employeesRes?.filter(
          (item) => item.companyId === companyId
        );
        setAllUsers(filteredEmployees);
      } catch (error) {
        console.error("Error fetching initial data:", error);
        setSettingsData([]);
        setAllUsers([]);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      getReportListData(startDate, endDate);
    }
  }, [startDate, endDate]);

  const getUniqueUserIds = (issueData) => {
    const userIds = new Set();

    issueData?.forEach((item) => {
      userIds?.add(item?.client?.id);
    });

    return Array.from(userIds);
  };

  const getLatestResponse = (responses) => {
    if (!responses || Object.keys(responses).length === 0) return null;
    return Object.values(responses).reduce((latest, response) => {
      return latest.respondOn > response.respondOn ? latest : response;
    });
  };

  const mapWithClientIds = async (clientIds, userData) => {
    getClientsList(clientIds, (result) => {
      const clientResult = result?.filter(
        (item) =>
          item.companyId === companyId &&
          (auth?.userProfile?.role !== "Client" || item?.id === clientId)
      );
      const data =
        auth?.userProfile?.role === "Client"
          ? userData?.filter((item) => item?.clientId === clientId)
          : userData;
      const filteredClients = clientResult?.filter((item) =>
        data?.some((data) => data.client.id === item.id)
      );
      const clients = filteredClients.map((item) => ({
        value: item.id,
        label: item.clientName,
      }));
      setClientNameList([{ label: "All", value: "All" }, ...clients]);

      const uniqueStatuses = new Set();

      const finaleData = data?.map((resItem) => {
        const userDetails = clientResult?.filter(
          (itm) => itm.id === resItem.client.id
        );

        const createdBy = allUsers?.filter(
          (item) => item.userId === resItem.createdBy
        );
        const date = FormatedDates(resItem.createdOn);
        const latestRes = getLatestResponse(resItem.responses);
        uniqueStatuses.add(resItem.status);

        resItem["clientName"] = userDetails[0]?.clientName;
        resItem["date"] = date;
        resItem["issueNumber"] = `IS - ${String(resItem?.issueNumber)
          .match(/\d+/)?.[0]
          .padStart(4, "0")}`;
        resItem["lastRes"] = FormatedDates(latestRes?.respondOn);
        resItem[
          "createdBy"
        ] = `${createdBy[0].firstName} ${createdBy[0].lastName}`;

        return resItem;
      });

      const statusOptions = Array.from(uniqueStatuses).map((status) => ({
        label: status,
        value: status,
      }));

      setStatusList([{ label: "All", value: "All" }, ...statusOptions]);

      let sortedData = sortingFunction(finaleData);
      setClientsListMaster(sortedData);

      setClientList(() =>
        sortedData?.filter((itme) => {
          let returnFlg = true;
          if (clientName !== "All") {
            returnFlg = itme.client.id === clientName;
          }
          if (status !== "All" && returnFlg) {
            returnFlg = itme.status === status;
          }
          return returnFlg;
        })
      );
    });
  };

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.clientName < b.clientName) return -1;
      if (a.clientName > b.clientName) return 1;
      // If clientName is the same, sort by date
      if (a.date < b.date) return -1;
      if (a.date > b.date) return 1;
      // If clientName && Dateis the same, sort by issueNumber
      if (a.issueNumber < b.issueNumber) return -1;
      if (a.issueNumber > b.issueNumber) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`,
    };
    try {
      const data = await getIssuesByDate(param);
      const details = data?.filter((item) => item.companyId === companyId);
      const id = getUniqueUserIds(details);

      mapWithClientIds(id, details);
    } catch (error) {
      console.error("Error fetching report list data:", error);
    }
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = clientsList?.filter(
        (item) => item.client.id === rcellItem.client.id
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.clientName,
          item?.date,
          item?.issueNumber,
          item?.createdBy,
          item.lastRes,
          item?.status,
          item?.priority,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.clientName,
          item?.date,
          item?.issueNumber,
          item?.createdBy,
          item.lastRes,
          item?.status,
          item?.priority,
        ];
      });
    }
    return clientCSV;
  };

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
      return [
        rcellItem?.clientName,
        rcellItem?.date,
        rcellItem?.issueNumber,
        rcellItem?.createdBy,
        rcellItem.lastRes,
        rcellItem?.status,
        rcellItem?.priority,
      ];
    } else {
      return [
        rcellItem?.clientName,
        rcellItem?.date,
        rcellItem?.issueNumber,
        rcellItem?.createdBy,
        rcellItem.lastRes,
        rcellItem?.status,
        rcellItem?.priority,
      ];
    }
  };

  const downloadForExcel = async (rcellItem, emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("Issues Report");

    const clientCSV = getDatatoDownload(rcellItem);
    let fileName;
    if (Array.isArray(rcellItem)) {
      fileName = `IssuesReport_${rcellItem[0]?.clientName}_${moment(
        startDate
      ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `IssuesReport_${rcellItem?.clientName}_${moment(
        startDate
      ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend
    );
  };

  const downloadForPDF = async (rcellItem, emailSend) => {
    const clientCSV = getDatatoDownload(rcellItem);
    let fileName;
    if (Array.isArray(rcellItem)) {
      fileName = `IssuesReport_${rcellItem[0]?.clientName}_${moment(
        startDate
      ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `IssuesReport_${rcellItem?.clientName}_${moment(
        startDate
      ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  };

  const setDownloadCSVData = (event, done, rcellItem) => {
    const clientCSV = getDatatoDownload(rcellItem);

    const reportName = "Issues Report";
    const clientName = Array.isArray(rcellItem)
      ? `${rcellItem[0]?.clientName}`
      : `${rcellItem?.clientName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
      endDate
    ).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Client Name: ${clientName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = "All";

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList.filter(
        (item) => item.value === clientName
      )[0].label;
    }
    let fileName = `IssuesReport_${clientNamefordwonLoad}_${moment(
      startDate
    ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  };

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet("Issues Report");
    let clientNamefordwonLoad = "All";

    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList.filter(
        (item) => item.value === clientName
      )[0].label;
    }
    let fileName = `IssuesReport_${clientNamefordwonLoad}_${moment(
      startDate
    ).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    return await downloadExcel(
      clientCSV,
      csvHeaders,
      wb,
      ws,
      fileName,
      emailSend
    );
  };

  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem)) {
      name = rcellItem[0]?.clientName;
    } else {
      name = rcellItem?.clientName;
    }

    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, emailSend),
      downloadForPDF(rcellItem, emailSend)
    ]);
    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "IssuesReport",
        ReportsName: "Client Report",
        Name: name,
        Date: startDate,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: ""
      }));
      navigate("/emailreports");
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend)
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
      ...prev,
        FileName: "IssuesReport",
        ReportsName: "Client Report",
        Name: clientNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: ""
      }));
      navigate("/emailreports");
    }
  }

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "clientName":
        if (
          rowindex !== 0 &&
          clientsList[rowindex - 1].clientName !== rcellItem.clientName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"IssuesReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            clientsList[rowindex - 1].clientName !== rcellItem.clientName
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"IssuesReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"IssuesReport"}
              />
            );
          } else {
            return "";
          }
        }

      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const tableRightComponent = () => {
    return (
      <div className="d-flex w320 editEmp issueAlign ph-8">
        <div className="mr-24 d-flex flex-center">
          {" "}
          <FilterAltIcon className="mv-7 issueicon" /> Filters{" "}
        </div>
        <div className="reportsMargin mv-7">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="Start Date"
              className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
                // if (newValue) {
                //   setEndDate(moment());
                // } else {
                //   setEndDate(null);
                // }
              }}
              maxDate={moment()}
              views={["year", "month", "day"]}
              inputFormat="YYYY-MM-DD"
            />
          </LocalizationProvider>
        </div>
        <div className="reportsMargin mv-7">
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
              label="End Date"
              className="customDate customDatePicker dark:[&_.MuiInputBase-input]:text-white dark:[&_.MuiInputLabel-root]:text-white"
              value={endDate}
              onChange={(newValue) => {
                setEndDate(newValue);
                // if (!newValue) {
                //   setStartDate(null);
                // }
              }}
              maxDate={moment()}
              views={["year", "month", "day"]}
              inputFormat="YYYY-MM-DD"
            />
          </LocalizationProvider>
        </div>
        <div className="reportsMargin mv-7">
          <SingleSelect
            value={clientName}
            className={`field reportsSingleSelect`}
            name={"clientName"}
            label={"Client Name"}
            onChange={(e) => handleclientNameChange(e)}
            options={clientNameList}
          />
        </div>
        <div className="reportsMargin mv-7">
          <SingleSelect
            value={status}
            className={`field reportsSingleSelect`}
            name={"status"}
            label={"Status"}
            onChange={(e) => handelStatusChange(e)}
            options={statusList}
          />
        </div>
      </div>
    );
  };

  return (
    <Container>
      <PageTitle
        pageTitle="Issues Reports"
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Reports" },
          { label: "Client Reports", to: "/reports/Clientreport" },
        ]}
        BreadCrumbCurrentPageTitle={"Issue Reports"}
        showLastSeen={true}
      ></PageTitle>
      <div className="sectionBox2 dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
        <TableToolbar rightComponent={tableRightComponent()} />
        <ThemeTable
          rows={clientsList}
          headCells={getColumns()}
          hidePagination={true}
          isLoading={isLoading}
          renderRowCell={renderRowCell}
        />
      </div>
      <div className={styles.report}>
        <div className={styles.download1}>
          <EmailRoundedIcon />
          <div>
            <Link
              to={clientsList.length !== 0 && "/emailreports"}
              rel="noopener"
            >
              <Button
                className={styles.actions}
                disabled={clientsList.length === 0}
                onClick={() => {
                  handelEmailFullReport();
                }}
              >
                Full Report
              </Button>
            </Link>
          </div>
        </div>
        <div className={styles.download1}>
          <PictureAsPdfIcon />
          <div>
            <Button
              className={styles.actions}
              disabled={clientsList.length === 0}
              onClick={() => {
                downloadForFullPDF();
              }}
            >
              Download Full Report
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default IssuesReports;
